module.exports = __webpack_public_path__ + "img/scissors.93ff224b.svg";